import { useState } from 'react'
import { useParams } from 'react-router'
import AxiosInstance from 'utils/AxiosInstance'
function ViewText(props) {
  const [scormNumber, setScormNumber] = useState(0)
  const [tracking, setTracking] = useState(null)
  const { id } = useParams()
  if (!tracking && scormNumber !== 0) {
    AxiosInstance.get(
      `/tracking?courseId=${props.course_id}&contentId=${scormNumber}`
    ).then((data) => {
      setTracking(data)
    })
  }

  const currentTextView = props.content.find((item) => item.id === parseInt(id))

  let scormStatus

  let suspendData =
    tracking && tracking.data && tracking.data.value ? true : false

  if (!suspendData) {
    scormStatus =
      '<p  id="notstarted_scorm_status" class="notstarted">Not Started</p>'
  } else if (props.finishedContent.includes(scormNumber.toString())) {
    scormStatus =
      '<p id="completed_scorm_status" class="completed">Completed</p>'
  } else {
    scormStatus =
      '<p id="inprogress_scorm_status" class="inprogress">In Progress</p>'
  }

  let scorm =
    currentTextView &&
    currentTextView.html &&
    currentTextView.html.split('scorm/')[1]

  let scormNumberfromUrl = Number(scorm && scorm.split('"')[0])

  if (
    scormNumber === 0 &&
    !isNaN(scormNumberfromUrl) &&
    currentTextView.html !== ''
  ) {
    setScormNumber(scormNumberfromUrl)
  }

  return (
    <div
      className='tl-employee-content-wrapper editor-data-styles sun-editor-editable h-100 scrollbar'
      // style={
      // 	this.props.hideCourseSidebar === 0 &&
      // 	this.props.collapse !== 'collapse' &&
      // 	window.matchMedia('(min-width:768px)').matches
      // 		? { right: 320, padding: 20 }
      // 		: { padding: 20 }
      // }
    >
      <div
        dangerouslySetInnerHTML={{
          __html: currentTextView
            ? currentTextView.html.replace('[scorm_status]', scormStatus)
            : null,
        }}
      />
    </div>
  )
}

export default ViewText
